/* https://github.com/callemall/material-ui/blob/master/docs/src/app/components/FullWidthSection.js */

import React from "react";
import assign from "lodash/assign";
import ClearFix from "material-ui/internal/ClearFix";
import { spacing as Spacing } from "material-ui/styles";
const DesktopGutter = Spacing.desktopGutter;

var FullWidthSection = React.createClass({
  propTypes: {
    useContent: React.PropTypes.bool,
    contentType: React.PropTypes.string,
    contentStyle: React.PropTypes.object
  },

  getDefaultProps: function() {
    return {
      useContent: false,
      contentType: "div"
    };
  },

  contextTypes: {
    isLarge: React.PropTypes.bool
  },

  getStyles: function() {
    return {
      root: {
        padding: DesktopGutter + "px",
        boxSizing: "border-box"
      },
      content: {
        maxWidth: "1200px",
        margin: "0 auto"
      },
      rootWhenSmall: {
        paddingTop: DesktopGutter * 2 + "px",
        paddingBottom: DesktopGutter * 2 + "px"
      },
      rootWhenLarge: {
        paddingTop: DesktopGutter * 3 + "px",
        paddingBottom: DesktopGutter * 3 + "px"
      }
    };
  },

  render: function() {
    var { style, useContent, contentType, contentStyle, ...other } = this.props;

    var styles = this.getStyles();

    var content;
    if (useContent) {
      content = React.createElement(
        contentType,
        { style: assign({}, styles.content, contentStyle) },
        this.props.children
      );
    } else {
      content = this.props.children;
    }

    return (
      <ClearFix
        {...other}
        style={assign(
          {},
          styles.root,
          style,
          !this.context.isLarge && styles.rootWhenSmall,
          this.context.isLarge && styles.rootWhenLarge
        )}
      >
        {content}
      </ClearFix>
    );
  }
});

export default FullWidthSection;



// WEBPACK FOOTER //
// ./src/app/components/full-width-section.jsx